import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../../helpers/createStyles";
import {filterHeadline, filterHTML} from "../../../helpers/filters";
import AngleDivider from "../../AngleDivider/AngleDivider";
import './AngledHeroContentBox.scss';

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldTxtSubTitle: string;
        fieldHtmlBody: Array<{
            processed: string;
        }>;
        fieldObjectMainheroItemStyle: Array<>;
    }
}

class AngledHeroContentBoxQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
    query paragraphById($id: String!) {
        paragraphById:paragraphRevisionById(id: $id) {
            ... on Paragraph {
                ... on Paragraph {
                    ... on ParagraphComponentContentboxAngledHero {
                        fieldTxtHeadline
                        fieldTxtSubTitle
                        fieldHtmlBody {
                            processed
                        }
                        fieldObjectMainheroItemStyle {
                            ... on FieldParagraphFieldObjectMainheroItemStyle {
                                ${fieldObjectSectionStyle}
                            }
                        }
                    }
                }
            }
        }
    }
`;

const AngledHeroContentBox = ({id, componentIndex, markComponentLoadedAs}) => (
    <AngledHeroContentBoxQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            const styles = fieldObjectSectionStyleCss(field.fieldObjectMainheroItemStyle);
            const isFirstComponent = componentIndex === 0;

            markComponentLoadedAs(id, true);

            return (
                <div className={`angledHeroContentBox${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    <div className="container">
                        {field.fieldTxtHeadline && isFirstComponent && (
                            // eslint-disable-next-line react/no-danger
                            <h1 className="angledHeroContentBox__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                        )}
                        {field.fieldTxtHeadline && !isFirstComponent && (
                            // eslint-disable-next-line react/no-danger
                            <h2 className="angledHeroContentBox__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                        )}
                        {field.fieldTxtSubTitle && isFirstComponent && (
                            // eslint-disable-next-line react/no-danger
                            <h2 className="angledHeroContentBox__subTitle" style={{fontSize: '18px'}} dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                        )}
                        {field.fieldTxtSubTitle && !isFirstComponent && (
                            // eslint-disable-next-line react/no-danger
                            <h3 className="angledHeroContentBox__subTitle" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                        )}
                        {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                            // eslint-disable-next-line react/no-danger
                            <div className="angledHeroContentBox__body" dangerouslySetInnerHTML={{__html: filterHTML(field.fieldHtmlBody.processed)}}/>
                        )}
                    </div>

                    {styles.childBackground.isActive && (
                        <AngleDivider topColor="transparent" bottomColor={styles.childBackground.css.backgroundColor}/>
                    )}

                    {styles.childBackground.isActive && (
                        <div className="angleDivider__bottom" style={{backgroundColor: `${styles.childBackground.css.backgroundColor}`}}/>
                    )}

                </div>
            );
        }}
    </AngledHeroContentBoxQuery>
);

AngledHeroContentBox.propTypes = {
    id: PropTypes.number.isRequired,
    componentIndex: PropTypes.number,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

AngledHeroContentBox.defaultProps = {
    componentIndex: null
};

export default AngledHeroContentBox;



// WEBPACK FOOTER //
// ./frontend/components/Hero/AngledHero/AngledHeroContentBox.jsx